module.exports = __webpack_public_path__ + "static/media/wavelab.71ba7c90.jpg";